export const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  APP: '/app',
  PRODUCTS: '/app/products',
  PRODUCTS_NEW: '/app/products/new',
  PRODUCT_DETAIL: (id: string) => `/app/products/${id}`,
  FREE_TEXT: '/app/free-text',
  ECOMMERCE: '/app/ecommerce',
  ECOMMERCE_NEW: '/app/ecommerce/new',
  ECOMMERCE_DETAIL: (id: string) => `/app/ecommerce/${id}`,
  CAMPAIGNS: '/app/campaigns',
  CAMPAIGNS_NEW: '/app/campaigns/new',
  NEWSLETTER_TEMPLATES: '/app/campaigns/templates/newsletter',
  NEWSLETTER_TEMPLATE_DETAIL: (id: string) => `/app/campaigns/templates/newsletter/${id}`,
  CAMPAIGN_DETAIL: (id: string) => `/app/campaigns/${id}`,
  CHATBOT: '/app/chatbot',
  CHATBOT_CONVERSATION: (id: string) => `/app/chatbot/${id}`,
  USAGE_GUIDELINES: '/app/usage-guidelines',
  NOT_FOUND: '/not-found',
} as const;
